export const blockIconsUiactionsFavoriteNew = (
	<span className='material-symbols-outlined'>favorite</span>
);
